
<div class="card-login">
  <div class="card-header" >

    <img src="https://cdn.mobilitycompany.it/images/mobility_company_logo_2023.svg" alt="Sharing"/>
  </div>
  <div class="card-body">

    <mat-spinner></mat-spinner>
   


  </div>
</div>




